import { render, staticRenderFns } from "./FilterStaticText.vue?vue&type=template&id=48d8ae1c"
import script from "./FilterStaticText.vue?vue&type=script&lang=js"
export * from "./FilterStaticText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports